import { FC } from 'react'
import dayjs from 'dayjs'
import {
  DropDownList,
  DropDownListChangeEvent
} from '@progress/kendo-react-dropdowns'
import { StackLayout } from '@progress/kendo-react-layout'

const currentYear = dayjs().year()

export interface ConstructionPeriodYearsDropDownListProps {
  /** startOrigin */
  startOrigin?: number
  /** startRange */
  startRange?: number
  /** endOrigin */
  endOrigin?: number
  /** endRange */
  endRange?: number
  /** Start year dropDownList value */
  startYearValue?: number
  /** End year dropDownList value */
  endYearValue?: number
  onStartYearChange?: (year: number) => void
  onEndYearChange?: (year: number) => void
  disabled?: boolean
  clear?: boolean
}

export const ConstructionPeriodYearsDropDownList: FC<ConstructionPeriodYearsDropDownListProps> = ({
  startOrigin = 0,
  startRange = 0,
  endOrigin = 0,
  endRange = 0,
  startYearValue,
  endYearValue,
  onStartYearChange,
  onEndYearChange,
  disabled = false,
  clear = false
}) => {
  const createStartData = () => {
    if (clear) {
      const years = Array.from({ length: startRange + 1 }).map(
        (_, index) => index > 0 ? currentYear + startOrigin + index - 1 : ''
      )
      return years
    } else {
      const years = Array.from({ length: startRange }).map(
        (_, index) => currentYear + startOrigin + index
      )
      return years
    }
  }

  const createEndData = () => {
    if (clear) {
      const years = Array.from({ length: endRange + 1 }).map(
        (_, index) => index > 0 ? currentYear + endOrigin + index - 1 : ''
      )
      return years
    } else {
      const years = Array.from({ length: endRange }).map(
        (_, index) => currentYear + endOrigin + index
      )
      return years
    }
  }

  const createValue = (yearValue?: number) => {
    return yearValue === undefined ? null : yearValue
  }

  const handleStartYearChange = (event: DropDownListChangeEvent) => {
    onStartYearChange?.(event.value)
  }

  const handleEndYearChange = (event: DropDownListChangeEvent) => {
    onEndYearChange?.(event.value)
  }

  return (
    <StackLayout orientation='horizontal'>
      <DropDownList
        data={createStartData()}
        value={createValue(startYearValue)}
        onChange={handleStartYearChange}
        disabled={disabled}
      />
      {'　～　'}
      <DropDownList
        data={createEndData()}
        value={createValue(endYearValue)}
        onChange={handleEndYearChange}
        disabled={disabled}
      />
    </StackLayout>
  )
}
